/**
 * Sections API - Feed Stats
 *
 * GET /v1/schools/:schoolId/sections/:sectionId/feed-stats
 *
 * Anchored on the lead section's publicId — non-lead publicIds collapse to the
 * lead before the Stream call (comms v2 U13).
 */

import { z } from 'zod'

export const SectionFeedStatsRequestSchema = z.object({
  schoolId: z.string().min(1),
  sectionId: z.string().min(1)
})

export type SectionFeedStatsRequest = z.infer<typeof SectionFeedStatsRequestSchema>

export const SectionFollowerInfoSchema = z.object({
  count: z.number(),
  list: z.array(z.unknown())
})

export const SectionFollowingInfoSchema = z.object({
  count: z.number(),
  list: z.array(z.unknown())
})

export const SectionFeedStatsDataSchema = z.object({
  feedId: z.string(),
  feedGroup: z.literal('section'),
  followers: SectionFollowerInfoSchema,
  following: SectionFollowingInfoSchema
})

export type SectionFeedStatsData = z.infer<typeof SectionFeedStatsDataSchema>

export const SectionFeedStatsResponseSchema = z.object({
  message: z.string(),
  data: SectionFeedStatsDataSchema
})

export type SectionFeedStatsResponse = z.infer<typeof SectionFeedStatsResponseSchema>
